import { render, staticRenderFns } from "./stdBomForm.vue?vue&type=template&id=1b2cdb11&scoped=true&"
import script from "./stdBomForm.vue?vue&type=script&lang=js&"
export * from "./stdBomForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2cdb11",
  null
  
)

export default component.exports